import { useEffect, useRef } from "react"

export function useDebouncedEffect(effect: () => void, deps: any[], delayMs: number) {
  const timerRef = useRef<number | null>(null)

  useEffect(() => {
    if (timerRef.current) window.clearTimeout(timerRef.current)

    timerRef.current = window.setTimeout(() => {
      effect()
    }, delayMs)

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current)
    }
  }, [...deps, delayMs])
}
